import { render, staticRenderFns } from "./aInspectionPlanDetailList.vue?vue&type=template&id=4c315619&scoped=true"
import script from "./aInspectionPlanDetailList.vue?vue&type=script&lang=js"
export * from "./aInspectionPlanDetailList.vue?vue&type=script&lang=js"
import style0 from "./aInspectionPlanDetailList.vue?vue&type=style&index=0&id=4c315619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c315619",
  null
  
)

export default component.exports